import { render, staticRenderFns } from "./Devicedoorrecord.vue?vue&type=template&id=b01b39ca&scoped=true"
import script from "./Devicedoorrecord.vue?vue&type=script&lang=js"
export * from "./Devicedoorrecord.vue?vue&type=script&lang=js"
import style0 from "./Devicedoorrecord.vue?vue&type=style&index=0&id=b01b39ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b39ca",
  null
  
)

export default component.exports